import ReportCard from '@/components/ReportCard';
import { useRequestSaver } from '@/hooks/RequestSaver';
import { useAppSelector } from '@/store/hooks';
import { selectHideClients, selectHideWhitelabels } from '@/store/selectors/me.selectors';
import { useEffect } from 'react';
import { useWebVisitsReporting } from '../Reporting/Hooks/useWebVisitsReporting';
import CampaignNameCard from './Components/Cards/CampaignNameCard';
import ChannelCard from './Components/Cards/ChannelCard';
import CreativeCard from './Components/Cards/CreativeCard';
import DeviceCard from './Components/Cards/DeviceCard';
import ImpressionCard from './Components/Cards/ImpressionCard';
import PublisherNameCard from './Components/Cards/PublisherNameCard';
import Filters from './Components/Filters/WebVisits';
import ImpressionsByTypeTable from './Components/ImpressionsByTypeTable';

const WebVisitsTab = () => {
  const requestSaver = useRequestSaver();

  const hideWhitelabels = useAppSelector(selectHideWhitelabels);
  const hideClients = useAppSelector(selectHideClients);

  const { applyFilters, loadReports, loadingFilterSource } = useWebVisitsReporting(requestSaver);

  useEffect(() => {
    loadReports();
  }, [loadReports]);

  return (
    <div className='grid grid-cols-4 gap-[30px]'>
      <div className='col-span-4'>
        <Filters
          onApplyFilters={applyFilters}
          loadingFilterSource={loadingFilterSource}
          hideWhitelabels={hideWhitelabels}
          hideClients={hideClients}
        />
      </div>
      <ReportCard className='col-span-4'>
        <ImpressionCard />
      </ReportCard>
      <ReportCard className='col-span-2'>
        <ChannelCard />
      </ReportCard>
      <ReportCard className='col-span-2'>
        <DeviceCard />
      </ReportCard>
      <ImpressionsByTypeTable requestSaver={requestSaver} />
      <ReportCard className='col-span-4'>
        <CampaignNameCard />
      </ReportCard>
      <ReportCard className='col-span-4'>
        <CreativeCard />
      </ReportCard>
      <ReportCard className='col-span-4'>
        <PublisherNameCard />
      </ReportCard>
    </div>
  );
};

export default WebVisitsTab;
